export const getArtifactUrl = (artifacts, prop) => {
  const artifact = artifacts[prop];

  if (!artifact || !artifact.url) {
    return undefined;
  }

  return artifact.url;
};